import React from "react";

import "./styles/style-process-box.css";

// issue #31: ao terminar, a tela so dizia "Upload success." ou "Upload error.".
// No sucesso o usuario nao sabia quantas linhas entraram; no erro recebia a
// mensagem crua do backend ("Missing field in duelist excel: SP Name", ou pior,
// um nome de tabela interna), sem saber o que fazer. Aqui os dois casos viram
// resumo: o que entrou, ou o que houve e como resolver.

// Traduz a mensagem tecnica do backend para causa e acao em linguagem de negocio.
// A mensagem original continua acessivel no bloco de detalhe tecnico.
const CAUSAS = [
    {
        teste: /duplicated order|logistic_map_IntegrityError/i,
        causa: "A planilha tem uma ordem repetida (mesmo documento e item).",
        acao: "Remova a linha duplicada e envie novamente. O SO e o item aparecem no detalhe tecnico.",
    },
    {
        teste: /Missing field in (duelist|zzorder) excel: (.+)/i,
        causa: (m) => `A coluna "${m[2]}" nao foi encontrada na planilha.`,
        acao: "Confira se a exportacao do SAP incluiu essa coluna e se o nome esta igual ao das importacoes anteriores.",
    },
    {
        teste: /Import No\. (.+?) n[aã]o encontrado/i,
        causa: (m) => `O Import No. ${m[1]} nao esta cadastrado.`,
        acao: "Cadastre essa importacao antes de subir a planilha, ou confira se o numero esta correto na origem.",
    },
    {
        teste: /Invoiced and rejected status not found/i,
        causa: "Os status de faturamento usados pela importacao nao estao cadastrados.",
        acao: "Verifique o cadastro de status em Management, ou acione o suporte.",
    },
    {
        teste: /could not convert string to float|invalid literal for int/i,
        causa: "Uma coluna numerica da planilha tem texto no lugar de numero.",
        acao: "Procure celulas preenchidas com texto em colunas como quantidade, rota ou codigo do cliente.",
    },
    {
        teste: /Excel file format cannot be determined|not a zip file/i,
        causa: "O arquivo enviado nao e uma planilha valida.",
        acao: "Reexporte do SAP em .xlsx e envie de novo, sem renomear a extensao.",
    },
    {
        teste: /took too long|timed out/i,
        causa: "A importacao demorou mais que o limite e foi interrompida.",
        acao: "Tente novamente. Se repetir, acione o suporte informando o horario da tentativa.",
    },
];

export const interpretarErro = (mensagem) => {
    const texto = String(mensagem || "");
    for (const item of CAUSAS) {
        const encontrado = texto.match(item.teste);
        if (encontrado) {
            return {
                causa: typeof item.causa === "function" ? item.causa(encontrado) : item.causa,
                acao: item.acao,
            };
        }
    }
    return {
        causa: "A importacao nao foi concluida.",
        acao: "Tente novamente. Se o erro repetir, acione o suporte com o detalhe tecnico abaixo.",
    };
};

const Numero = ({ rotulo, valor }) => (
    <div className="scm-painel__numero">
        <dt>{rotulo}</dt>
        <dd>{Number(valor || 0).toLocaleString("pt-BR")}</dd>
    </div>
);

/**
 * Resumo do fim da importacao.
 *
 * <ImportSummary tipo="sucesso" arquivo="X.xlsx" resumo={{created, updated}} aoFechar={fn} />
 * <ImportSummary tipo="erro" arquivo="X.xlsx" mensagem="..." aoFechar={fn} />
 */
const ImportSummary = ({ tipo, arquivo, resumo, mensagem, aoFechar }) => {
    const deuCerto = tipo === "sucesso";
    const explicacao = deuCerto ? null : interpretarErro(mensagem);

    return (
        <section className="scm-painel" aria-live="polite">
            <header>
                <span className={`scm-painel__selo ${deuCerto ? "scm-painel__selo--ok" : "scm-painel__selo--erro"}`}>
                    {deuCerto ? "Importacao concluida" : "Importacao nao concluida"}
                </span>
                {arquivo ? <p className="scm-painel__arquivo">{arquivo}</p> : null}
            </header>

            {deuCerto ? (
                <>
                    <dl className="scm-painel__numeros">
                        <Numero rotulo="Ordens criadas" valor={resumo && resumo.created} />
                        <Numero rotulo="Ordens atualizadas" valor={resumo && resumo.updated} />
                    </dl>
                    <p className="scm-painel__nota">
                        Os dados ja estao disponiveis em Due List, List.
                    </p>
                </>
            ) : (
                <>
                    <p className="scm-painel__causa">
                        {explicacao.causa}
                        <span className="scm-painel__acao">{explicacao.acao}</span>
                    </p>
                    {mensagem ? (
                        <details className="scm-painel__tecnico">
                            <summary>Detalhe tecnico</summary>
                            <pre>{mensagem}</pre>
                        </details>
                    ) : null}
                </>
            )}

            {aoFechar ? (
                <button type="button" className="scm-painel__botao" onClick={aoFechar}>
                    {deuCerto ? "Enviar outra planilha" : "Tentar novamente"}
                </button>
            ) : null}
        </section>
    );
};

export default ImportSummary;
